export const GET_MESSAGES_ENDPOINT ='/api/v1/message';